import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import api from "@/common/utils/api";
import { AdminCreateDemoAppType } from "@reflag/shared/adminAPI";
import { ErrorResponse } from "@reflag/shared/api";
import { AppHeaderDTO } from "@reflag/shared/appAPI";

export function useAdminDemoAppCreateMutation(orgId: string) {
  const queryClient = useQueryClient();

  return useMutation<
    AppHeaderDTO,
    AxiosResponse<ErrorResponse>,
    AdminCreateDemoAppType
  >({
    mutationKey: ["admin", "org", orgId, "app"],
    mutationFn: (body) =>
      api
        .post<"/admin/:orgId/apps">(`/admin/${orgId}/apps`, body)
        .then((res) => res.data),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ["orgs"],
      });
    },
  });
}
